import React, { FC, Fragment } from 'react';

import { ITheme } from '@/src/assets/interfaces/themeInterface';

import DemoCard from '../demoCard/DemoCard';

import styles from './ThemesList.module.scss';

type TList = {
    themesData: Partial<ITheme>[];
    activeTag?: string;
    handleFilters?: (activeTag: string) => void;
    additionalClass?: string;
};

const ThemesList: FC<TList> = ({ themesData, activeTag, handleFilters, additionalClass }) => {
    let index = -1;

    return (
        <ul className={styles.themes__list + ' ' + `${additionalClass && styles[additionalClass]}`}>
            {themesData.map((item) => {
                const { demoList } = item;

                const filteredList =
                    demoList && activeTag
                        ? activeTag === 'All Categories'
                            ? demoList
                            : demoList.filter((item) => item.demoTag === activeTag)
                        : demoList;
                return (
                    <Fragment key={`${item._id}-${index}`}>
                        {filteredList &&
                            filteredList.map((demo) => {
                                index += 1;
                                return (
                                    <li
                                        data-index={index}
                                        key={`${demo._key}-${index}`}
                                        className={styles.tag__item}>
                                        <DemoCard
                                            demoData={demo}
                                            theme={item}
                                            handleFilters={handleFilters}
                                            displayTag={
                                                demoList && demoList.length > 1 ? true : false
                                            }
                                        />
                                    </li>
                                );
                            })}
                    </Fragment>
                );
            })}
        </ul>
    );
};

export default ThemesList;
